import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { calculateRem } from '@uie/javascript-style-helpers';
import { colors } from '@vds/theme';
import { InputField as CoreInputField } from '@vds-core/inputs';
import { BodyConfig, Body, TypographyConfig } from '@vds/typography';
var propTypes = {
  required: PropTypes.bool
};
var defaultProps = {
  required: true
};

var InputField = function InputField(props) {
  var readOnly = props.readOnly,
      locked = props.locked,
      error = props.error,
      readOnlyBorders = props.readOnlyBorders,
      type = props.type;

  function _calculateInputPadding(error, readOnly, locked, type, readOnlyBorders) {
    if (type === 'calendar') {
      if ((readOnly || locked) && !readOnlyBorders) {
        return calculateRem(12, 16, 12, 32);
      } else {
        return calculateRem(12, 16, 12, 50);
      }
    } else {
      if ((readOnly || locked) && !readOnlyBorders) {
        return 0;
      } else {
        return calculateRem(12, 16);
      }
    }
  }

  return /*#__PURE__*/React.createElement(CoreInputField, _extends({}, props, {
    maxWidth: undefined,
    minWidth: undefined,
    hoverState: false,
    overflowEllipsis: false,
    readOnlyBorders: false,
    inputHeight: calculateRem(42),
    required: props.required,
    bodyConfig: BodyConfig,
    typescale: TypographyConfig.getTypescale(),
    labelMarginBottom: calculateRem(1),
    calculateInputPadding: _calculateInputPadding,
    inlineActionButtonLabel: undefined,
    showPasswordButtonLabel: undefined,
    hidePasswordButtonLabel: undefined,
    onClickInlineAction: undefined,
    renderErrorIcon: false,
    TextLink: undefined,
    CreditCardIcon: undefined,
    helperText: undefined,
    helperTextPlacement: undefined,
    Tooltip: undefined,
    tooltipTitle: undefined,
    tooltipContent: undefined,
    success: false,
    successText: undefined,
    dateFormat: undefined
  }));
};

InputField.propTypes = propTypes;
InputField.defaultProps = defaultProps;
export default InputField;